<template>
  <div class="wrap-edit-text-heading">
    <Teleport to="#tooltips">
      <Tooltip :pointer="true" width="auto" />
    </Teleport>
    <div class="row-wrapper">
      <div class="wrap-row">
        <div class="setting-left">Font Weight</div>
        <div class="setting-right">
          <GfDropdown
            :is-scroll-dropdown="isScrollDropdown"
            b-class="btn-dropdown"
            :value="parseDataSetting.fontWeight"
            dropdown-class="dropdownClass"
            :options="FONT_WEIGHT"
            f-type="simple"
            @selected="onChangeFontWeight" />
        </div>
      </div>
      <div class="wrap-row">
        <div class="setting-left">Font Style</div>
        <div class="setting-right">
          <GfDropdown
            :is-scroll-dropdown="isScrollDropdown"
            b-class="btn-dropdown"
            :value="parseDataSetting.fontStyle"
            dropdown-class="dropdownClass"
            :options="FONT_STYLE"
            f-type="simple"
            @selected="onChangeFontStyle" />
        </div>
      </div>
      <div class="wrap-row">
        <div class="setting-left">Font Size</div>
        <div class="setting-right" @mouseover="fontSizeMouseOver" @mouseleave="fontSizeMouseLeave">
          <GfInputUnit
            :value="parseDataSetting.fontSize.value"
            :unit="parseDataSetting.fontSize.unit"
            :units="fontSizeInputUnits"
            :min="0"
            :decimal="parseDataSetting.fontSize.unit == 'px' ? 2 : 3"
            @change="onChangeFontsize"
            @on-change="onChangeFontsize" />
        </div>
      </div>
      <div class="wrap-row">
        <div class="setting-left">Decoration</div>
        <div class="setting-right">
          <div class="wrap-decoration-action">
            <div class="wrap-action">
              <a
                v-popover:tooltip.top="'None'"
                class="action-link"
                :class="{ active: parseDataSetting.decoration === 'none' }"
                @click="chooseDecoration('none')">
                <i class="icon icon-decoration-unset action-icon" />
              </a>
            </div>
            <div class="wrap-action">
              <a
                v-popover:tooltip.top="'Underline'"
                class="action-link"
                :class="{ active: parseDataSetting.decoration === 'underline' }"
                @click="chooseDecoration('underline')">
                <i class="icon icon-decoration-underline action-icon" data-icon="underline" />
              </a>
            </div>
            <div class="wrap-action">
              <a
                v-popover:tooltip.top="'Line through'"
                class="action-link last-item"
                :class="{ active: parseDataSetting.decoration === 'line-through' }"
                @click="chooseDecoration('line-through')">
                <i class="icon icon-decoration-align action-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-row">
        <div class="setting-left">Line Height</div>
        <div class="setting-right">
          <GfInputUnit
            :units="lineHeightInputUnits"
            :unit="parseDataSetting.lineHeight.unit"
            :value="parseDataSetting.lineHeight.value"
            :decimal="2"
            :min="0"
            @on-change="onChangeLineHeight"
            @change="onChangeLineHeight" />
        </div>
      </div>
      <div class="wrap-row">
        <div class="setting-left">Letter Spacing</div>
        <div class="setting-right">
          <GfInputUnit
            :units="lettterSpacingInputUnits"
            :unit="parseDataSetting.letterSpacing.unit"
            :value="parseDataSetting.letterSpacing.value"
            @on-change="onChangeLetterSpacing"
            @change="onChangeLetterSpacing" />
        </div>
      </div>
      <!--      <div class="wrap-row">-->
      <!--        <div class="setting-left">-->
      <!--          Font Color-->
      <!--        </div>-->
      <!--        <div class="setting-right font-color">-->
      <!--          <div class="font-color-box" @click="openEditFontColor" :style="{'background': styleFontColor}"></div>-->
      <!--          <div class="font-color-palette" v-if="isOpenEditFontColor">-->
      <!--            <GfColorPalette @editColorStyle="editColorStyle" @pickColor="onPickFontColor" @onClosePallete="isOpenEditFontColor = false"/>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import GfDropdown from '@/core/components/base/GfDropdown.vue';
import GfInputUnit from '@/core/components/base/GfInputUnit.vue';
// import GfColorPalette from "@/core/components/base/GfColorPalette.vue";
import { COLOR_KEYS_MAP } from '@/constants/global-style';
import { mapGetters, mapState } from 'vuex';

const FONT_WEIGHT = [
  { name: 'Thin 100', value: 100 },
  { name: 'Semi Thin 200', value: 200 },
  { name: 'Light 300', value: 300 },
  { name: 'Regular 400', value: 400 },
  { name: 'Medium 500', value: 500 },
  { name: 'Semi Bold 600', value: 600 },
  { name: 'Bold 700', value: 700 },
  { name: 'Super Bold 800', value: 800 },
  { name: 'Boldest', value: 900 },
];

const FONT_STYLE = [
  { name: 'Normal', value: 'normal' },
  { name: 'Italic', value: 'italic' },
];

export default {
  name: 'TextHeading',
  components: {
    GfDropdown,
    GfInputUnit,
    // GfColorPalette
  },
  props: {
    dataSetting: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: -1,
    },
  },
  emits: ['onClickPopover', 'editColorStyle', 'onChangeDataSetting'],
  data: () => ({
    FONT_WEIGHT,
    FONT_STYLE,
    decoActive: 'none',
    lineHeightInputUnits: [{ value: 'em', name: 'em' }],
    lettterSpacingInputUnits: [{ value: 'px', name: 'px' }],
    inputUnits: [
      { value: 'px', name: 'px' },
      { value: '%', name: '%' },
      { value: 'em', name: 'em' },
    ],
    fontSizeInputUnits: [
      { value: 'px', name: 'px' },
      { value: 'rem', name: 'rem' },
    ],
    parseDataSetting: {},
    isOpenEditFontColor: false,
    visibleTooltipFontSize: false,
  }),
  computed: {
    ...mapGetters('sidebar', {
      getCurrentPresetColor: 'getCurrentPresetColor',
    }),
    toolTipFontSize() {
      if (isNaN(parseFloat(this.parseDataSetting.fontSize.value))) {
        return '0 px';
      }
      if (this.parseDataSetting.fontSize.unit == 'rem') {
        return (this.parseDataSetting.fontSize.value * this.parseDataSetting.baseSize.value).toFixed(2) + ' px';
      }
      return `${this.parseDataSetting.fontSize.value}${this.parseDataSetting.fontSize.unit}`;
    },
    styleFontColor() {
      if (this.parseDataSetting.fontColor.includes('transparent')) {
        return '';
      }
      return this.parseDataSetting.fontColor;
    },
    isScrollDropdown() {
      return true;
    },
  },
  watch: {
    dataSetting() {
      this.parseDataSettings();
    },
  },
  created() {
    this.parseDataSettings();
  },
  methods: {
    parseDataSettings() {
      this.parseDataSetting = {
        ...this.dataSetting,
        baseSize: this.getValueWithDataUnit(this.dataSetting.baseSize),
        fontSize: this.getValueWithDataUnit(this.dataSetting.fontSize),
        lineHeight: this.getValueWithDataUnit(this.dataSetting.lineHeight),
        letterSpacing: this.getValueWithDataUnit(this.dataSetting.letterSpacing),
      };
    },
    chooseDecoration(value) {
      this.parseDataSetting.decoration = value;
      this.convertDataSetting();
      this.$emit('onClickPopover');
    },
    getValueWithDataUnit(data) {
      if (data.includes("%")) {
        data = data.replace("%", "");
        return {
          value: data,
          unit: "%",
        };
      }
      const result = data.match(/[a-z]+|[^a-z]+/gi);
      return {
        value: result[0],
        unit: result[1],
      };
    },
    fontSizeMouseOver() {
      this.visibleTooltipFontSize = true;
    },
    fontSizeMouseLeave() {
      this.visibleTooltipFontSize = false;
    },
    // not used
    // validateFontSize(fontSize) {
    //   if (isNaN(parseFloat(fontSize.value))) {
    //     this.parseDataSetting.fontSize.value = 0.5.toString();
    //   }

    //   if (parseFloat(fontSize.value) < 0.5) {
    //     this.parseDataSetting.fontSize.value = (0.5).toString();
    //   }

    //   if (parseFloat(fontSize.value) > 4.5) {
    //     this.parseDataSetting.fontSize.value = (4.5).toString();
    //   }

    //   this.parseDataSetting.fontSize.unit = "rem";
    // },
    // toFixedFontSize() {
    //   this.parseDataSetting.fontSize.value = parseFloat(this.parseDataSetting.fontSize.value).toFixed(2).toString();
    // },
    // changeFontSize(fontSize) {
    //   this.validateFontSize(fontSize);
    //   this.toFixedFontSize();
    //   this.convertDataSetting(true);
    // },
    onChangeFontsize(fontSize) {
      if (!fontSize.value) {
        fontSize.value = 0;
      }
      if (fontSize.unit != this.parseDataSetting.fontSize.unit) {
        if (fontSize.unit == 'px' && this.parseDataSetting.fontSize.unit == 'rem') {
          this.parseDataSetting.fontSize.value = parseFloat(
            (fontSize.value * this.parseDataSetting.baseSize.value).toFixed(2),
          );
          this.parseDataSetting.fontSize.unit = fontSize.unit;
        } else if (fontSize.unit == 'rem' && this.parseDataSetting.fontSize.unit == 'px') {
          this.parseDataSetting.fontSize.value = parseFloat(
            (fontSize.value / this.parseDataSetting.baseSize.value).toFixed(3),
          );
          this.parseDataSetting.fontSize.unit = fontSize.unit;
        }
      } else {
        this.parseDataSetting.fontSize = fontSize;
      }
      this.convertDataSetting(true);
    },
    onChangeFontWeight(fontWeight) {
      this.parseDataSetting.fontWeight = fontWeight.value;
      this.convertDataSetting();
    },
    onChangeFontStyle(fontStyle) {
      this.parseDataSetting.fontStyle = fontStyle.value;
      this.convertDataSetting();
    },
    onChangeLineHeight(lineHeight) {
      this.parseDataSetting.lineHeight = lineHeight;
      this.convertDataSetting();
    },
    onChangeLetterSpacing(letterSpacing) {
      this.parseDataSetting.letterSpacing = letterSpacing;
      this.convertDataSetting();
    },
    openEditFontColor() {
      this.isOpenEditFontColor = true;
    },
    onPickFontColor(color) {
      this.parseDataSetting.fontColor = `var(--${COLOR_KEYS_MAP[color.name]})`;
      this.convertDataSetting();
      this.isOpenEditFontColor = false;
    },
    editColorStyle() {
      this.$emit('editColorStyle');
    },
    convertDataSetting(chaneFontSize) {
      const value = {
        ...this.parseDataSetting,
        baseSize: this.parseDataSetting.baseSize.value + this.parseDataSetting.baseSize.unit,
        fontSize: this.parseDataSetting.fontSize.value + this.parseDataSetting.fontSize.unit,
        lineHeight: this.parseDataSetting.lineHeight.value + this.parseDataSetting.lineHeight.unit,
        letterSpacing: this.parseDataSetting.letterSpacing.value + this.parseDataSetting.letterSpacing.unit,
      };

      this.$emit('onChangeDataSetting', { value, index: this.index, chaneFontSize: chaneFontSize });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.wrap-edit-text-heading {
  .row-wrapper {
    flex-basis: auto;

    .wrap-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;

      .setting-left {
        display: flex;
        align-items: center;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: #aaaaaa;
      }

      .setting-right {
        .tooltip_font-size {
          background: #676767;
          border-radius: 4px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          top: -36px;
          right: -50px;

          .label {
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 14px;
            color: #fff;
            margin-left: 8px;
            margin-right: 8px;
            padding-bottom: 0;
          }

          &:after {
            content: '';
            position: absolute;
            bottom: -4px;
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #676767;
            clear: both;
          }
        }

        display: flex;
        align-items: center;

        :deep(.btn-dropdown) {
          width: 120px;
          border: 1px solid map-get($hybrid-shade-dark, '200');
          background-color: inherit;
        }

        :deep(.gf_control-input) {
          width: 120px;
        }

        .wrap-decoration-action {
          display: flex;
          border-left: 1px solid map-get($hybrid-shade-dark, '200');
          border-top-left-radius: $radius;
          -moz-border-radius-topleft: $radius;
          -webkit-border-top-left-radius: $radius;
          border-bottom-left-radius: $radius;
          -moz-border-radius-bottomleft: $radius;
          -webkit-border-bottom-left-radius: $radius;

          .wrap-action {
            height: 32px;

            .action-link {
              border: 1px solid map-get($hybrid-shade-dark, '200');
              border-left: 0;
              height: 32px;
              width: 32px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              .action-icon {
                font-size: 16px;
              }

              &:hover {
                background: map-get($hybrid-shade-dark, '200');
              }
            }

            .active {
              background: map-get($hybrid-shade-dark, '200');
            }

            .last-item {
              border-top-right-radius: $radius;
              -webkit-border-top-right-radius: $radius;
              -moz-border-radius-topright: $radius;
              border-bottom-right-radius: $radius;
              -webkit-border-bottom-right-radius: $radius;
              -moz-border-radius-bottomright: $radius;
            }
          }
        }

        .font-color {
          position: relative;

          &-box {
            width: 32px;
            height: 32px;
            border: 1px solid map-get($hybrid-shade-dark, '200');
            border-radius: $radius;
            background-image: url('/editor/static/icons/transparent-color.svg');
            background-size: cover;
            cursor: pointer;
          }

          &-palette {
            position: absolute;
            bottom: 40px;
            left: 28px;
          }
        }
      }
    }
  }
}
</style>
